import React from 'react'
import { RecordListActions } from '../../../ui/gov-actions'
import RecordHeading from '../../../ui/record-heading'
import RecordMessages from '../../../ui/record-messages'
import GovMessages from '../../../ui/gov-messages'
import ExportAdvances from '../export-advances'
import ExportOutstandingCWAs from '../export-missing-approvals'
import migrateToXplor from '../gov-actions/migrate-to-xplor'
import markAsMigrated from '../gov-actions/mark-as-migrated'
import releaseCWAS from '../gov-actions/release-cwas'

const actionsForRecord = ({ record }) => [
  migrateToXplor({ record }),
  markAsMigrated({ record }),
  releaseCWAS({ record }),
]

const GovRegistrationView = ({ record = {}, children }) => (
  <div className="govRegistrationDetail">
    <RecordHeading record={record}>
      <div>
        <ExportAdvances record={record} />
        <ExportOutstandingCWAs record={record} />
      </div>
    </RecordHeading>
    <GovMessages record_type={`${record.type}s`} record_id={record.type_id} />
    <RecordListActions labelText="Actions" options={actionsForRecord({ record })} />
    <RecordMessages
      messages={
        record.show_ccms_message
          ? [
            {
              message: 'Xplor is not managing CCMS so Xplor CCMS reports will not be accurate',
            },
          ]
          : null
      }
    />
    {children}
  </div>
)

export default GovRegistrationView



// WEBPACK FOOTER //
// ./src/gov-registrations/details/views/index.jsx